import { useCallback, useEffect, useState } from 'react';
import { fetchBillingAttempts } from '../api/billingAttempts';
import type { BillingAttempt } from '../types';

export const useBillingAttempts = (shopifyCustomerId: string) => {
  const [billingAttempts, setBillingAttempts] = useState<BillingAttempt[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const fetchData = useCallback(async () => {
    if (!shopifyCustomerId) return;

    await Promise.resolve();
    setLoading(true);
    setError(null);

    try {
      const response = await fetchBillingAttempts(shopifyCustomerId, page, perPage);
      setBillingAttempts(response.items);
      setTotal(response.pagination.total);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
      setBillingAttempts([]);
    } finally {
      setLoading(false);
    }
  }, [shopifyCustomerId, page, perPage]);

  useEffect(() => {
    void Promise.resolve().then(fetchData);
  }, [fetchData]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePerPageChange = (newPerPage: number) => {
    setPerPage(newPerPage);
    setPage(1); // Reset to first page when changing per page
  };

  return {
    billingAttempts,
    loading,
    error,
    page,
    total,
    perPage,
    totalPages: Math.ceil(total / perPage),
    handlePageChange,
    handlePerPageChange,
    refetch: fetchData,
  };
};
